var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toolbar-entity"},[_c('r-button-action',{attrs:{"title":"Назад","icon":"arrow-left"},nativeOn:{"click":function($event){return _vm.goBack.apply(null, arguments)}}}),_c('user-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }